/**
 * TEC-296: el contrato del API que este código del app necesita (`App\Support\ApiContract::VERSION`).
 *
 * Con una instancia por cliente, un app recién publicado puede hablar con una instancia que todavía no
 * se actualiza. Si la instancia reporta un contrato menor, el app muestra "Estamos actualizando el
 * servicio" en vez de fallar con errores sueltos (ForceUpdateService).
 *
 * Súbelo sólo en el PR del app que dependa de un cambio incompatible del API (el mismo número que
 * subió el API). Nunca se baja.
 */
export const MIN_API_CONTRACT = 1;

/** `api` de GET app-settings. */
export interface ApiContractInfo {
  contract?: number | null;
  release?: string | null;
}

/**
 * ¿La instancia va detrás de lo que este app necesita? Un API anterior a TEC-296 no manda `api` y
 * cuenta como contrato 1: con MIN_API_CONTRACT = 1 nunca bloquea. Pura, para las pruebas.
 */
export function apiBehind(info: ApiContractInfo | null | undefined, minimum = MIN_API_CONTRACT): boolean {
  const contract = typeof info?.contract === 'number' && Number.isFinite(info.contract) ? info.contract : 1;

  return contract < minimum;
}
